import { Box, Icon, Text } from "@chakra-ui/react";
import * as SlateIcons from "@medstonetech/slate-icons";

type IconComponent = React.ElementType<React.SVGProps<SVGSVGElement>>;

function IconsPage() {
  const slateIcons = SlateIcons as unknown as Record<string, IconComponent>;
  const createIcon = slateIcons.createIcon;

  const icons = Object.entries(slateIcons).filter(
    (entry): entry is [string, IconComponent] => {
      const [, value] = entry;
      return (
        typeof value === "object" && value !== null && value !== createIcon
      );
    }
  );

  return (
    <Box w="100%" minH="100vh" p={4} textAlign="center">
      <Text fontSize="2rem" fontWeight="600" pb={3}>
        Slate Icons
      </Text>
      <Box display="flex" justifyContent="start" flexWrap="wrap" gap={6}>
        {icons.map(([name, SlateIcon]) => (
          <Box
            key={name}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Icon as={SlateIcon} fontSize="5rem" color="blue" />
            {name}
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export { IconsPage };
